"use client";

import Link from "next/link";
import ImageComponent from "@/components/ui/ImageComponent";
import { CrouselDataProps } from "@/util/enum";
import {
  isExternalHref,
  useCityAwareBannerHref,
} from "@/hooks/useCityAwareBannerHref";

interface HomeBannerStaticHeroProps {
  slide: CrouselDataProps;
}

/**
 * First hero slide only — renders on SSR and initial paint so LCP is not blocked
 * by Swiper hydration. The viewport-correct asset is selected via `<picture>` in
 * `ImageComponent` (no JS breakpoint, no `useIsMobile`).
 */
export default function HomeBannerStaticHero({ slide }: HomeBannerStaticHeroProps) {
  const href = useCityAwareBannerHref(slide.linkTo);

  const content = (
    <div className="relative w-full">
      <div className="w-full rounded-none md:rounded-3xl overflow-hidden">
        <ImageComponent
          url={slide.url}
          mobile_url={slide.mobile_url}
          img_title={slide.alt_name}
          imgPriority={true}
          object_cover={false}
          fullWidthNaturalHeight
        />
      </div>
    </div>
  );

  if (!href) return content;

  if (isExternalHref(href)) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className="block">
        {content}
      </a>
    );
  }

  return (
    <Link href={href} className="block">
      {content}
    </Link>
  );
}
